import { EcommerceLogo } from "../../../app/models/general/ecommerceLogo";
import { MainLogo } from "./components/MainLogo";
import { ShortLogo } from "./components/ShortLogo";

export const ecommerceLogo: EcommerceLogo = {
  mainLogo: MainLogo,
  shortLogo: ShortLogo,
};
